// extracted by mini-css-extract-plugin
export default {"slide":"Slide_slide__UrtTF","slide__title":"Slide_slide__title__OT064","slide__graphic":"Slide_slide__graphic__ex4Xl","slide__text":"Slide_slide__text__9+kyM"};